<template>
  <div>
    <div class="itemslick js-gallery-main">
      <slick
        v-if="loading"
        :class="{'show' : show}"
        class="js-gallery-thumb gallery gallery--main"
        ref="slick"
        :options="slickOptions"
        @afterChange="handleAfterChange"
        @beforeChange="handleBeforeChange"
        @breakpoint="handleBreakpoint"
        @destroy="handleDestroy"
        @edge="handleEdge"
        @init="handleInit"
        @reInit="handleReInit"
        @setPosition="handleSetPosition"
        @swipe="handleSwipe"
        @lazyLoaded="handleLazyLoaded"
        @lazyLoadError="handleLazeLoadError"
      >
        <div v-for="img in images" :key="img.id" class="item inner-middle">
          <div class="thumb">
            <img class="item__img show" :src="img.url" :data-zoom-image="img.url">
          </div>
        </div>
        <div v-if="images.length == 0" class="item inner-middle">
          <div class="thumb">
            <img
              class="item__img show"
              src="../../assets/img/default-noimg.png"
              data-zoom-image="../../assets/img/default-noimg.png"
            >
          </div>
        </div>
      </slick>
    </div>
    <ItemSlickSub v-if="images.length > 1" :images="images" :goToimg="goToimg"/>
  </div>
</template>
<script>
import Slick from "vue-slick";
import ItemSlickSub from "@/components/items/ItemSlickSub.vue";
import { setTimeout } from "timers";
import mediumZoom from "medium-zoom";
export default {
  name: "itemslick",
  components: {
    Slick,
    ItemSlickSub,
    mediumZoom
  },
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        accessibility: false
      },
      goToimg: 0,
      show: false,
      loadZoom: false
    };
  },
  watch: {
    goToimg(val) {
      this.$refs.slick.goTo(val);
    },
    images() {
      this.reInit();
    }
  },
  updated() {
    if (this.loadZoom == false) {
      this.loadZoom = true;
      this.setZoom();
    }
  },
  methods: {
    setZoom() {
      mediumZoom("img.item__img.show");
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      setTimeout(() => {
        this.loading = true;
        this.$nextTick(() => {
          this.$refs.slick.reSlick();
          this.setZoom();
        });
      }, 1000);
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      this.goToimg = currentSlide;
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      this.goToimg = currentSlide;
    },
    handleBreakpoint(event, slick, breakpoint) {},
    handleDestroy(event, slick) {},
    handleEdge(event, slick, direction) {},
    handleInit(event, slick) {},
    handleReInit(event, slick) {},
    handleSetPosition(event, slick) {},
    handleSwipe(event, slick, direction) {},
    handleLazyLoaded(event, slick, image, imageSource) {},
    handleLazeLoadError(event, slick, image, imageSource) {}
  },
  beforeDestroy() {
    $(".zoomContainer").remove();
  }
};
</script>

<style lang="scss">
.medium-zoom-overlay {
  z-index: 10;
}
.item__img.medium-zoom-image.medium-zoom-image--opened {
  z-index: 100;
}
.gallery--main .item .thumb {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>